import { createFileRoute } from "@tanstack/react-router";

import OnboardingSummaryPage from "@/pages/Onboarding/OnboardingSummaryPage";

export const Route = createFileRoute("/app/companies/$company_id/onboarding/summary")({
  component: OnboardingSummaryPage,
});
